import { API_ENDPOINT } from './config';

export const urlsRoomReservations = {
  reservations: `${API_ENDPOINT}/reservations`,
  reservationsForOverview: `${API_ENDPOINT}/reservations?type=forOverview`,
  reservationDetail: (id, isEdit) =>
    isEdit
      ? `${API_ENDPOINT}/reservations/${id}?edit=true`
      : `${API_ENDPOINT}/reservations/${id}`,
  reservationsConflicts: `${API_ENDPOINT}/reservations/conflicts`,
  reservationsCollidedSubjects: `${API_ENDPOINT}/reservations/collidedSubjects`,
  reservationsImport: `${API_ENDPOINT}/reservations/import`,

  reservationsSequence: `${API_ENDPOINT}/reservations/sequences`,
  reservationSequenceDetail: (id, isEdit) =>
    isEdit
      ? `${API_ENDPOINT}/reservations/sequences/${id}?edit=true`
      : `${API_ENDPOINT}/reservations/sequences/${id}`,
  reservationsSequencesConflicts: `${API_ENDPOINT}/reservations/sequences/conflicts`,
  reservationsSequencesCollidedSubjects: `${API_ENDPOINT}/reservations/sequences/collidedSubjects`,

  teachers: `${API_ENDPOINT}/teachers`,

  reservationsSubjects: `${API_ENDPOINT}/reservations/subjects`,

  reservationsChangeStateByEmail: (newState, token) =>
    `${API_ENDPOINT}/reservations/changeReservationStateByEmail?newState=${newState}&token=${token}`,
  reservationsChangeStateInCms: (newState, id) =>
    `${API_ENDPOINT}/reservations/changeReservationStateInCms/${id}?newState=${newState}`,

  roomResponsibles: `${API_ENDPOINT}/room-responsibles`,
  roomResponsibleDetail: (id) => `${API_ENDPOINT}/room-responsibles/${id}`,

  rooms: `${API_ENDPOINT}/rooms`,
  roomsForReservation: `${API_ENDPOINT}/rooms?forReservations`,
  roomDetail: (id) => `${API_ENDPOINT}/rooms/${id}`,

  confirmReservationSequence: `${API_ENDPOINT}/reservations/confirm-sequence`,
};

export const routesRoomReservations = {
  // Public
  reservationsOverview: '/rezervacie-miestnosti',
  reservationsChangeState: '/schvalovanie-rezervacii',

  // CMS
  cmsRooms: '/cms/rooms',
  cmsRoomsEdit: '/cms/rooms/edit',
  cmsRoomsCreate: '/cms/rooms/create',
  cmsRoomResponsible: '/cms/room-responsibles',
  cmsRoomResponsibleEdit: '/cms/room-responsibles/edit',
  cmsRoomResponsibleCreate: '/cms/room-responsibles/create',
  cmsReservations: '/cms/reservations',
  cmsReservationsEdit: '/cms/my-reservations/edit',
  cmsReservationsCreate: '/cms/my-reservations/create',
  cmsReservationsCreateParams: '/cms/my-reservations/new',
  cmsReservationSequenceEdit: '/cms/my-reservations/reservation-sequences/edit',
  cmsReservationSequenceCreate:
    '/cms/my-reservations/reservation-sequences/create',
  cmsReservationOverview: '/cms/reservations-overview',
};
